var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',{attrs:{"image-url":_vm.imageUrl('add'),"data-cy":"open-new-security-modal","tooltip":"Add Security","action-id":_vm.id},on:{"actionButtonClick":_vm.openModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }